// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconImage: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="16"
            viewBox="0 0 16 16"
            stroke="currentColor"
            fill="currentColor"
        >
            <path d="M1.875 0.8125C0.84960938 0.8125 0 1.6621094 0 2.6875L0 12.0625C0 13.087891 0.84960938 13.9375 1.875 13.9375L11.25 13.9375C12.275391 13.9375 13.125 13.087891 13.125 12.0625L13.125 2.6875C13.125 1.6621094 12.275391 0.8125 11.25 0.8125L1.875 0.8125ZM3.75 3.15625C4.5410156 3.15625 5.15625 3.7714844 5.15625 4.5625C5.15625 5.3535156 4.5410156 5.96875 3.75 5.96875C2.9589844 5.96875 2.34375 5.3535156 2.34375 4.5625C2.34375 3.7714844 2.9589844 3.15625 3.75 3.15625ZM7.96875 6.4375C8.203125 6.4375 8.4375 6.5546875 8.5839844 6.7890625L11.162109 11.007812C11.279297 11.212891 11.279297 11.476562 11.162109 11.710938C11.044922 11.916016 10.810547 12.0625 10.546875 12.0625L2.578125 12.0625C2.3144531 12.0625 2.0800781 11.916016 1.9628906 11.681641C1.8457031 11.447266 1.8457031 11.183594 1.9921875 10.949219L3.6328125 8.6054688C3.7792969 8.4296875 3.984375 8.3125 4.21875 8.3125C4.453125 8.3125 4.6582031 8.4296875 4.8046875 8.6054688L5.5664062 9.71875L7.3828125 6.7890625C7.5 6.5839844 7.734375 6.4375 7.96875 6.4375Z" />
        </svg>
    );
};

export default React.memo(IconImage);
